export enum TipoTemplateModalEnum {
    DEFAULT = 'default',
    APENAS_SELECT_VARIAVEL = 'apenas_select_variavel',
    SELECT_OPERADOR_VALOR = 'select_operador_valor',
    DIA_SEMANA = 'dia_semana',
    HORARIO_PARA_LIGAR = 'horario_para_ligar',
    HORARIO_PROIB = 'horario_proib',
}
